import { loginNameSpace } from "&features/login/login.i18n";

let en = {
  login: loginNameSpace.en,
};

export default en;
